import { createStore } from 'vuex'
import axios from 'axios'
import router from '../router/inquiry'

const Inquiry = {
  namespaced: true,
  state: {
    // テンプレート一覧
    component: ["InquiryNew", 'InquiryThanks'],
    inquiry: {}
  },
  mutations: {
    updateInquiryForm (state, value) {
      state.inquiry = value.form
    }
  },

  getters: {
    getComponent (state, getters, rootState) {
      return state.component[rootState.stepCount]
    },
    getValue (state, getters, rootState) {
      return state.inquiry
    }
  }
}

export default createStore({
  strict: process.env.NODE_ENV != 'production' || process.env.NODE_ENV != 'qa',
  state: {
    stepCount: 0,
    onClickSubmit: false
  },

  mutations: {
    // テンプレートを使うための更新用
    setStepCount (state) {
      state.stepCount++
    },
    setNewCount(state) {
      state.stepCount = 0
    },
    setThanksCount (state) {
      state.stepCount = 1
    },
    setOnClickSubmit (state) {
      state.onClickSubmit = true
    },
    resetOnClickSubmit (state) {
      state.onClickSubmit = false
    }
  },

  modules: {
    inquiry: Inquiry
  }
})
